// client\src\pages\Pesquisa.jsx

import React, { useState, useEffect, useRef } from 'react';
import styles from '../../App.module.css';
import api from '../../api/axios';
import { FaTimes } from 'react-icons/fa';
import { FaPen } from "react-icons/fa";

import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import '../../css/notifications.css';
import { isAuthenticated } from '../../index'
import notifications from '../../components/notifications';
import ListaFormularios from "../../components/ListaFormularios";
import { PacmanLoader } from 'react-spinners';




function Pesquisa({ query = "", close }) {

    // troque o uso de `appOrigin` por:
    const appOrigin = (typeof window !== "undefined" && window.location?.appOrigin) ? window.location.appOrigin : "";
    // estado p/ travar notificação repetida
    const [noResultToastShown, setNoResultToastShown] = useState(false);
    const [notificationType, setNotificationType] = useState(0);
    const { authenticated, userPermission, userStatus, timestamp, userLogin, userId, userCpf } = isAuthenticated();
    useEffect(() => {
        if (notificationType && notifications[notificationType]) {
            notifications[notificationType]();
            setNotificationType(0);
        }
    }, [notificationType, setNotificationType]);
    /* Variáveis de cadastro PRODUCAO */
    const [nome, setNome] = useState("");
    const [contato, setContato] = useState("");
    const [ClienteId, setClienteId] = useState("");
    const [vendedorProd, setVendedorProd] = useState("");
    /* Variáveis para Filtro */
    const [filtroVendedorProd, setFiltroVendedorProd] = useState(0);
    const [filtroProdutor, setFiltroProdutor] = useState(0);
    const [dataReady, setDataReady] = useState(false); // controla se já tentamos carregar a lista
    const [filtroStatusProd, setFiltroStatusProd] = useState(0);
    const [usersListProd, setUsersListProd] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const textareaRef = useRef(null);
    const [isModalOpenForm, setIsModalOpenForm] = useState(false);
    const [currentFormContent, setCurrentFormContent] = useState('');
    const [currentFormId, setCurrentFormId] = useState('');
    const [isModalOpenAnalise, setIsModalOpenAnalise] = useState(false);
    const [currentAnaliseContent, setCurrentAnaliseContent] = useState(''); // Conteúdo da análise de perfil
    const [formularios, setFormularios] = useState({});
    const [vendedoresList, setVendedoresList] = useState([]);
    const [produtoresList, setProdutoresList] = useState([]);
    const [clienteDetails, setClienteDetails] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    useEffect(() => { setSearchTerm(query); }, [query]);
    async function getClienteDetails(clienteID) {
        if (!clienteID) {
            console.log("ClienteID é inválido ou não fornecido");
            return; // Retorna antecipadamente se clienteID for inválido
        }
        try {
            const response = await api.get(`/clienteAgiliza/${clienteID}`);
            setClienteDetails(response.data);
            setNome(response.data.Nome);
            setContato(response.data.contato);
        } catch (error) {
            console.error("Error fetching client details", error);
        }
    }
    useEffect(() => {
        getClienteDetails(ClienteId);
    }, [ClienteId]);
    async function getUsers() {
        try {
            const res = await api.get(`/usuariosComFormularios?userPermission=${userPermission}&CPF=${userCpf}`);
            const { users } = res.data;
            if (!users || !Array.isArray(users)) {
                console.error('Erro: `users` não é um array válido:', users);
                setUsersListProd([]);
                setFilteredDataProd([]);
                NotificationManager.error('Resposta inválida ao carregar usuários.', 'Erro');
                return;
            }
            setUsersListProd(users);
            setFilteredDataProd(users);
            const formulariosMap = users.reduce((acc, user) => {
                if (user.formularios && Array.isArray(user.formularios)) {
                    acc[user.produzirId] = user.formularios;
                } else {
                    acc[user.produzirId] = [];
                }
                return acc;
            }, {});
            setFormularios(formulariosMap);
        } catch (error) {
            console.error('Erro ao buscar usuários e formulários:', error);
            NotificationManager.error('Não foi possível carregar usuários e formulários.', 'Erro');
        }
        finally {
            setDataReady(true); // <<< AQUI: marca que já carregou (ou tentou carregar)
        }
    }

    const getVendedoresProdutores = async () => {
        try {
            const resVendedoresProdutores = await api.get('/vendedores-produtores');
            // Verifica se a resposta possui a chave `data`
            if (resVendedoresProdutores.data && Array.isArray(resVendedoresProdutores.data.data)) {
                const users = resVendedoresProdutores.data.data;
                setVendedoresList(users.filter(user => user.is_vendedor === 1));
                setProdutoresList(users.filter(user => user.is_produtor === 1));
            } else {
                console.error('Formato inesperado da resposta:', resVendedoresProdutores.data);
                NotificationManager.error('Erro ao carregar vendedores e produtores.', 'Erro');
            }
        } catch (error) {
            console.error('Erro ao carregar dados:', error);
            NotificationManager.error('Erro ao carregar dados.', 'Erro');
        }
    }

    useEffect(() => {
        if (userPermission === 1) {
            setVendedorProd(userStatus);
        }
        if (userPermission === 2) {
            setFiltroProdutor(userStatus);
            setFiltroStatusProd(-2);
        }
        getVendedoresProdutores();
        getUsers(); // Agora inclui usuários e formulários
    }, []);


    // Normaliza removendo acento, pontuação e caixa
    const normalize = (text) =>
        (text ?? "")
            .toString()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "") // remove acentos
            .replace(/[^\p{L}\p{N}]+/gu, "") // remove pontuação/espaços (unicode)
            .toLowerCase();

    // Achata qualquer objeto/array em uma string única
    const flattenValues = (val) => {
        if (val == null) return "";
        if (Array.isArray(val)) return val.map(flattenValues).join(" ");
        if (typeof val === "object") return Object.values(val).map(flattenValues).join(" ");
        return String(val);
    };

    const [filteredDataProd, setFilteredDataProd] = useState([]);
    /////////////////////////////////
    useEffect(() => {
        const normalizedSearch = normalize(searchTerm);
        const next = usersListProd.filter((user) => {
            // Status
            const statusMatch =
                filtroStatusProd === 0 ||
                user.produzirStatus == filtroStatusProd ||
                (filtroStatusProd === -2 && (user.produzirStatus == 0 || user.produzirStatus == 2));
            // Vendedor / Produtor
            const vendedorMatch = filtroVendedorProd == 0 || user.vendedor == filtroVendedorProd;
            const produtorMatch = filtroProdutor == 0 || user.produtor == filtroProdutor;
            // Monta um "haystack" gigante com tudo que possa identificar o usuário
            const login = normalize(user.login || "");
            const vendedor = normalize(user.vendedor || "");
            const produtor = normalize(user.produtor || "");
            const nomeCliente = normalize(user.nomeCompleto || user.Nome || "");
            const contatoCliente = normalize(user.contato || "");
            // Formularios
            const forms = Array.isArray(user.formularios) ? user.formularios : [];
            const formsBlob = forms.map((f) => {
                let ds160 = normalize((f.ds160_id ?? "").toString());
                let data = {};
                try { data = JSON.parse(f.formularioData || "{}"); } catch { }
                const flat = normalize(flattenValues(data));
                return [ds160, flat].join(" ");
            }).join(" ");
            // Tudo junto
            const haystack = [login, vendedor, produtor, nomeCliente, contatoCliente, formsBlob].join(" ");
            const searchMatch = !normalizedSearch || haystack.includes(normalizedSearch);
            return statusMatch && vendedorMatch && produtorMatch && searchMatch;
        });
        setFilteredDataProd(next);
    }, [usersListProd, filtroVendedorProd, filtroProdutor, filtroStatusProd, searchTerm]);



    useEffect(() => {
        if (!dataReady) return; // <<< não notifica antes de carregar
        const someFilterApplied =
            (searchTerm && searchTerm.trim().length > 0) ||
            filtroVendedorProd != 0 ||
            filtroProdutor != 0 ||
            filtroStatusProd != 0;
        if (someFilterApplied && filteredDataProd.length === 0) {
            // só mostra 1x até o estado mudar
            if (!noResultToastShown) {
                NotificationManager.info('Nenhum resultado encontrado. Ajuste a busca ou os filtros.', 'Sem resultados');
                setNoResultToastShown(true);
            }
        } else {
            // reset quando houver resultados ou sem filtros/termo
            if (noResultToastShown) setNoResultToastShown(false);
        }
    }, [filteredDataProd.length, searchTerm, filtroVendedorProd, filtroProdutor, filtroStatusProd, noResultToastShown]);
    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = 'auto';
            textareaRef.current.style.height = `${Math.min(textareaRef.current.scrollHeight, 400)}px`;
        }
    }, [inputValue]);
    const renderFormContent = (content) => {
        try {
            // Tenta converter o conteúdo em um objeto JSON
            const parsedContent = typeof content === "string" ? JSON.parse(content) : content;
            // Inicializa arrays para perguntas informadas e não informadas
            const informed = [];
            const notInformed = [];
            // Itera sobre as entradas do JSON
            Object.entries(parsedContent).forEach(([key, value]) => {
                const isEmpty =
                    value === null ||
                    value === undefined ||
                    value === "" ||
                    (Array.isArray(value) && value.length === 0) ||
                    (typeof value === "object" && Object.keys(value).length === 0);
                if (isEmpty) {
                    notInformed.push(key); // Adiciona a pergunta ao array de "Não informado"
                } else {
                    const displayValue = Array.isArray(value)
                        ? value.join(", ")
                        : typeof value === "object"
                            ? JSON.stringify(value)
                            : value;
                    informed.push(
                        <div key={key} style={{ marginBottom: "10px" }}>
                            <strong>{key}:</strong> {displayValue}
                        </div>
                    );
                }
            });
            return (
                <div>
                    {/* Renderiza as perguntas informadas */}
                    <div>
                        <h3>Informações Preenchidas</h3>
                        {informed.length > 0 ? informed : <p>Nenhuma informação preenchida.</p>}
                    </div>
                    {/* Renderiza as perguntas não informadas */}
                    {notInformed.length > 0 && (
                        <div style={{ marginTop: "20px", padding: "10px", border: "1px solid #ccc", borderRadius: "5px" }}>
                            <h3>Perguntas Não Informadas</h3>
                            {notInformed.map((key) => (
                                <div key={key} style={{ marginBottom: "5px" }}>
                                    <strong>{key}</strong>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            );
        } catch (error) {
            console.error("Erro ao renderizar conteúdo do formulário:", error);
            return <div>Erro ao exibir o conteúdo</div>;
        }
    };
    // Cores fixas para alternar entre os grupos
    const groupColors = ['#8BAED3', '#F29098', '#808EA3', '#C0ECAE'];


    
    if (!dataReady) {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "40vh",
                    flexDirection: "column",
                    gap: "16px"
                }}
            >
                <PacmanLoader color="#162768" size={40} />
                <p style={{ fontSize: 16, color: "#162768" }}>Carregando dados...</p>
            </div>
        );
    }
    return (
        <div className={styles.app}>
            <NotificationContainer />
            <div className={styles.cadastroClienteContainerPesquisa}
            >
                <div style={{ display: "flex", width: "100%" }}>
                    <div
                        style={{
                            height: "100%"
                        }}
                    >
                        <ListaFormularios
                            users={filteredDataProd.filter(user => user.status !== 1)}
                            groupColors={groupColors}
                            onClickVer={(user) => window.location.href = `${appOrigin}/formularios/${user.clienteId}`}
                            onClickAnalise={(user) => {/* Se quiser modal de análise, exibe modal aqui */ }}
                            setCurrentFormContent={setCurrentFormContent}
                            setCurrentFormId={setCurrentFormId}
                            setIsModalOpenForm={setIsModalOpenForm}
                            tipo="pendencias" // ou "producao"
                        />
                    </div>
                </div>
            </div>
            {isModalOpenAnalise && (
                <div className={styles.modalProducaoForm}>
                    <div className={styles.modalContentProducaoForm}>
                        <div className={styles.closeForm} onClick={() => setIsModalOpenAnalise(false)}>&times; Fechar</div>
                        <h2>Conteúdo da Análise de Perfil</h2>
                        <p>{currentAnaliseContent}</p>
                    </div>
                </div>
            )}
            {isModalOpenForm && (
                <div className={styles.modalProducaoForm}>
                    <div className={styles.modalContentProducaoForm}>
                        <div className={styles.closeForm} onClick={() => setIsModalOpenForm(false)}><FaTimes /> Fechar</div>
                        <a href={`${appOrigin}/preencher/${currentFormId}`}>
                            <div className={styles.closeForm} style={{ backgroundColor: "var(--corOn)", color: 'black' }}><FaPen />   Editar</div>
                        </a>
                        <h2>Conteúdo da DS-160</h2>
                        <p>Form ID: {currentFormId}</p>
                        {/* <p>{currentFormContent}</p> */}
                        <div>{renderFormContent(currentFormContent)}</div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Pesquisa;